import { FlowsFiRenewalContactSectionModel } from "./flows-fi-renewal-contact-section.model";

export const LOGIN_FALSE: FlowsFiRenewalContactSectionModel = {
  isAuthorized: false,
  customerEmail: "test@vattenfall.se",
  phoneNumber: "07012345674",
  customerName: "Charles Steven",
  customerNumber: "090909009",
  premiseAddress: {
    streetName: "53 drottingnan street",
    postalCode: "11730",
    postalTown: "Stockholm",
  },
  responseCode: "200",
};

export const LOGIN_TRUE: FlowsFiRenewalContactSectionModel = {
  isAuthorized: true,
  customerName: "Charles Steven",
  customerEmail: "test@vattenfall.se",
  customerNumber: "090909009",
  phoneNumber: "07012345676",
  premiseAddress: {
    streetName: "53 drottingnan street",
    postalCode: "11730",
    postalTown: "Stockholm",
  },
  responseCode: "5001",
};
export const LOGIN_ERROR: FlowsFiRenewalContactSectionModel = {
  isAuthorized: false,
  customerEmail: "test@vattenfall.se",
  phoneNumber: "07012345675",
  customerName: "Charles Steven",
  customerNumber: "090909009",
  premiseAddress: {
    streetName: "53 drottingnan street",
    postalCode: "11730",
    postalTown: "Stockholm",
  },
  responseCode: "5001",
};

export const data: FlowsFiRenewalContactSectionModel[] = [LOGIN_TRUE, LOGIN_FALSE, LOGIN_ERROR];
